import React from 'react';

const ArStep1_2 = ({ ...props }) => {
  return (
    <svg
      {...props}
      width="262"
      height="178"
      viewBox="0 0 262 178"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M261 173H0.999988" stroke="#33415C" strokeLinecap="round" />
      <path
        d="M186.5 176V56.0136C186.5 54.2064 184.293 53.326 183.049 54.637L69.2038 174.623C67.9947 175.898 68.898 178 70.6546 178H184.5C185.605 178 186.5 177.105 186.5 176Z"
        fill="url(#paint0_linear_687_6511)"
      />
      <rect
        width="18"
        height="4"
        rx="2"
        transform="matrix(-0.809185 -0.587554 -0.588017 0.808849 198 56)"
        fill="#33415C"
      />
      <circle r="17" transform="matrix(-1 0 0 1 229 17)" fill="#ADB5BD" />
      <path
        d="M233.492 40.5509C233.933 33.8002 242.746 32 244.95 32C257.318 32 258.602 41.8397 259.483 48.5889L259.491 48.6518C260.372 55.4026 259.932 77.905 259.491 84.2057C259.051 90.5064 258.61 90.9564 255.525 95.4569C252.441 99.9574 251.559 117.959 251.119 126.96C250.678 135.961 252.881 148.113 253.763 150.813C254.644 153.513 259.932 171.065 246.712 171.965C233.492 172.865 231.289 156.214 232.17 126.96C233.052 97.7072 238.34 95.4569 235.255 92.3066C232.17 89.1562 233.492 78.8863 233.492 73.8546V50.9021C233.492 49.1019 233.052 47.3017 233.492 40.5509Z"
        fill="#ADB5BD"
      />
      <mask
        id="mask0_687_6511"
        maskUnits="userSpaceOnUse"
        x="232"
        y="32"
        width="28"
        height="140"
      >
        <path
          d="M233.492 40.5509C233.933 33.8002 242.746 32 244.95 32C257.318 32 258.602 41.8397 259.483 48.5889L259.491 48.6518C260.372 55.4026 259.932 77.905 259.491 84.2057C259.051 90.5064 258.61 90.9564 255.525 95.4569C252.441 99.9574 251.559 117.959 251.119 126.96C250.678 135.961 252.881 148.113 253.763 150.813C254.644 153.513 259.932 171.065 246.712 171.965C233.492 172.865 231.289 156.214 232.17 126.96C233.052 97.7072 238.34 95.4569 235.255 92.3066C232.17 89.1562 233.492 78.8863 233.492 73.8546V50.9021C233.492 49.1019 233.052 47.3017 233.492 40.5509Z"
          fill="#ADB5BD"
        />
      </mask>
      <g mask="url(#mask0_687_6511)">
        <path
          d="M248.212 49.0331L232.47 69.5233L232.068 75.929L235.704 79.584L246.854 71.3324L249.199 53.9431L248.212 49.0331Z"
          fill="url(#paint1_linear_687_6511)"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M230.06 72.5843C230.616 72.2067 231.119 71.7286 231.538 71.1545L248.642 47.7355C250.597 45.0595 250.008 41.3105 247.328 39.3618C244.648 37.4132 240.891 38.0028 238.936 40.6788L223.276 62.1204L200.879 55.4889C197.966 54.6266 194.903 56.2878 194.037 59.1993C193.171 62.1108 194.83 65.1701 197.743 66.0325L224.591 73.9815C226.598 74.576 228.678 73.9712 230.06 72.5843Z"
        fill="#ADB5BD"
      />
      <circle r="2.5" transform="matrix(-1 0 0 1 134.5 160.5)" fill="#EF476F" />
      <circle r="2.5" transform="matrix(-1 0 0 1 127.5 167.5)" fill="#EF476F" />
      <circle r="2.5" transform="matrix(-1 0 0 1 84.5 167.5)" fill="#EF476F" />
      <circle r="2.5" transform="matrix(-1 0 0 1 165.5 167.5)" fill="#EF476F" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M37 58.9164C50.8862 55.8437 61.2725 43.459 61.2725 28.6484C61.2725 22.0908 59.2363 16.0087 55.7618 11C67.2972 13.6589 75.8981 23.9931 75.8981 36.3361C75.8981 50.6955 64.2575 62.3361 49.8981 62.3361C45.2044 62.3361 40.8011 61.0923 37 58.9164Z"
        fill="#0466C8"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M39.2725 58.451C51.9865 54.5837 61.2382 42.7663 61.2382 28.788C61.2382 24.4797 60.3593 20.3767 58.7711 16.6484C62.1391 21.032 64.1414 26.5198 64.1414 32.4751C64.1414 46.4556 53.1071 57.8588 39.2725 58.451Z"
        fill="#0353A4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M112.562 80.2152C114.967 81.3596 117.659 82 120.5 82C130.717 82 139 73.7173 139 63.5C139 53.2827 130.717 45 120.5 45C120.242 45 119.986 45.0053 119.731 45.0157C118.595 39.8586 113.998 36 108.5 36C106.145 36 103.956 36.7076 102.133 37.9217C100.573 34.4318 97.0703 32 93 32C89.0327 32 85.605 34.3103 83.9889 37.6589C82.0633 36.6014 79.8519 36 77.5 36C70.0622 36 64.0292 42.015 64.0001 49.446C55.9841 51.2649 50 58.4336 50 67C50 76.9411 58.0589 85 68 85C72.4851 85 76.5871 83.3596 79.7387 80.646C83.368 85.7046 89.2991 89 96 89C102.889 89 108.965 85.5167 112.562 80.2152Z"
        fill="#CED4DA"
      />
      <defs>
        <linearGradient
          id="paint0_linear_687_6511"
          x1="183.956"
          y1="53.6926"
          x2="170.008"
          y2="175.299"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EF476F" />
          <stop offset="1" stopColor="#EF476F" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_687_6511"
          x1="240.921"
          y1="51.6675"
          x2="247.544"
          y2="55.7428"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.107993" stopColor="#33415C" />
          <stop offset="0.89927" stopColor="#C4C4C4" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default ArStep1_2;
